import { render } from "./live-header.vue?vue&type=template&id=45dad615"
import script from "./live-header.vue?vue&type=script&lang=js"
export * from "./live-header.vue?vue&type=script&lang=js"

import "./live-header.vue?vue&type=style&index=0&id=45dad615&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__